// extracted by mini-css-extract-plugin
export default {"root":"HistoryLink_root__SyU7X","applied":"HistoryLink_applied__o3mPN","link":"HistoryLink_link__1ijX8","placeHolderShimmer":"HistoryLink_placeHolderShimmer__ZtdRR"};